import { render, staticRenderFns } from "./SelectionPerson.vue?vue&type=template&id=b68e7582&"
import script from "./SelectionPerson.vue?vue&type=script&lang=js&"
export * from "./SelectionPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports